module.exports = __webpack_public_path__ + "static/IMG-20200906-WA0003-31752c2557c01aa52f23205f49d90b06.jpg";